import { render, staticRenderFns } from "./ambiente.vue?vue&type=template&id=83af0eca"
import script from "./ambiente.vue?vue&type=script&lang=js"
export * from "./ambiente.vue?vue&type=script&lang=js"
import style0 from "./ambiente.vue?vue&type=style&index=0&id=83af0eca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports